import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { explainPaperStyle, explainExampleTitleStyle, explainPaperTitleStyle, explainPaperTextStyle, explainExamplePaperStyle, explainExampleTextStyle, explainExampleImageBoxStyle} from '../../../../styles/commonStyles';

// 연수 메타데이터
export interface TrainingMetadata {
  id: string;
  title: string;
  category: string;
  description: string;
  instructor: string;
  duration: string;
  date: string;
  tags: string[];
  materials: string[];
  status: 'active' | 'completed' | 'upcoming';
  path: string;
}

export const trainingMetadata: TrainingMetadata = {
  id: '1',
  title: '대광고등학교 AI 에듀테크 연수',
  category: 'ai-edutech',
  description: '교육현장에서 AI 에듀테크를 활용한 수업 설계 및 실습 연수입니다.',
  instructor: '한지호',
  duration: '2시간',
  date: '2025-10-01',
  tags: ['AI', '에듀테크', '수업설계', '교육혁신'],
  materials: ['AIEdutechTraining.tsx', 'AI활용가이드.pdf'],
  status: 'active',
  path: '/teacher-training/digital/AIEdutechTraining'
};

const DeaGwamgAIEdutechTraining: React.FC = () => {
  const navigate = useNavigate();
  const exampleRef = useRef<HTMLDivElement>(null);
  const practiceRef = useRef<HTMLDivElement>(null);
  const [isPdfExpanded, setIsPdfExpanded] = useState(false);

  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100%', 
      boxSizing: 'border-box', 
      padding: '24px', 
      margin: 0, 
      display: 'flex', 
      flexDirection: 'column',
      overflow: 'auto'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
        <button
          onClick={() => navigate('/teacher-training/training-pages')}
          style={{
            marginRight: '16px',
            padding: '8px 16px',
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          ← 돌아가기
        </button>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', margin: 0 }}>
          대광고등학교 (동부) 학교로 찾아가는 2025 AI 디저털 역량 강화 연수
        </h1>
      </div>
      <div style={{ 
        marginBottom: '24px', 
        border: '1px solid #ccc', 
        padding: '16px', 
        borderRadius: '8px', 
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        backgroundColor: 'white'
      }}>
        <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.25rem' }}>
          📚 목차
        </h2>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          <li style={{marginBottom: '8px'}}>
            <a href="#연수-개요" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              연수 개요
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#ai-에듀테크란" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              AI 에듀테크란?
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#주요-활용-도구" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              주요 활용 도구
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#공유하기" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              참여자 공유 게시판
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#수업-적용-사례" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              수업 적용 사례
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#실습-과제" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              실습 과제
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#참고-자료" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              참고 자료
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#만족도-조사" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              연수 만족도 조사
            </a>
          </li>
        </ul>
      </div>
      {/* 연수 소개 */}
      <div style={{ display: 'flex', alignItems: 'end', marginBottom: '24px', gap: '16px' }}>
        <p style={{ color: '#666', margin: 0, fontSize: '1rem', lineHeight: '1.6' }}>
          대광고등학교 선생님들과 함께하는 AI 디지털 역량강화 연수페이지입입니다.<br/>
          교육 현장에서 AI 도구를 효과적으로 활용하여 수업을 설계하고 운영하는 방법을 다룹니다.<br/>
        </p>
      </div>
      {/* 연수 개요 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="연수-개요">
        연수 개요
      </h2>
      <div style={{
        backgroundColor: '#f8f9fa',
        border: '2px solid #667eea',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '16px'
      }}>
        <p style={{ 
          color: '#333', 
          margin: 0, 
          fontSize: '1.125rem', 
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          📅 연수 일정: 2025년 10월 1일 (수) 13:00 ~ 15:00 (2시간)
        </p>
      </div>
      <p style={{ color: '#666', marginBottom: '8px', fontSize: '1rem', lineHeight: '1.6' }}>
        본 연수는 다음과 같은 내용으로 구성됩니다.
      </p>
      <ul style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        <li>
          <b>AI 에듀테크의 이해</b>: AI가 교육에 미치는 영향과 활용 가능성
        </li>
        <li>
          <b>주요 도구 소개</b>: Gemini, NotebookLM, Padlet, Canva AI 등 교육용 AI 도구 활용법
        </li>
        <li>
          <b>수업 설계 실습</b>: AI를 활용한 수업 자료 제작 및 평가 방법
        </li>
        <li>
          <b>사례 공유</b>: 실제 교육 현장에서의 AI 활용 사례
        </li>
      </ul>
      {/* AI 에듀테크란 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="ai-에듀테크란">
        AI 에듀테크란?
      </h2>
      <p style={{ color: '#666', marginBottom: '8px', fontSize: '1rem', lineHeight: '1.6' }}>
        AI 에듀테크(AI EdTech)는 인공지능 기술을 활용하여 교육의 효과성과 효율성을 높이는 교육 기술입니다.
      </p>
      <ul style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        <li>
          <b>개인화 학습</b>: 학생 개개인의 학습 수준과 속도에 맞춘 맞춤형 학습 제공
        </li>
        <li>
          <b>교사 업무 지원</b>: 수업 자료 제작, 평가 문항 개발, 피드백 작성 등 행정 업무 자동화
        </li>
        <li>
          <b>학습 분석</b>: 학습 데이터 분석을 통한 학생의 강점과 약점 파악
        </li>
        <li>
          <b>상호작용 강화</b>: AI 챗봇, 음성 인식 등을 통한 학습 상호작용 증진
        </li>
      </ul>
      {/* 주요 활용 도구 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.5rem' }} id="주요-활용-도구">
        주요 활용 도구
      </h2>
      <p style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.6' }}>
        본 연수에서 다루는 주요 AI 도구는 다음과 같습니다.
      </p>

      {/* 도구 카드 그리드 */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
        gap: '24px',
        marginBottom: '32px'
      }}>
        {/* Padlet 카드 */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <h3 style={{ 
            fontSize: '1.25rem', 
            fontWeight: '600', 
            margin: 0,
            color: '#FF4081'
          }}>
            🎨 Padlet
          </h3>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            fontWeight: '500'
          }}>
            협업 보드 플랫폼
          </p>
          <ul style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            paddingLeft: '20px',
            lineHeight: '1.6'
          }}>
            <li>학생들의 아이디어 공유 및 협업 공간 제공</li>
            <li>실시간 피드백 및 댓글 기능</li>
            <li>다양한 미디어 형식 지원</li>
          </ul>
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '8px',
            marginTop: 'auto'
          }}>
            <a 
              href="https://padlet.com" 
              target="_blank" 
              rel="noopener"
              style={{
                display: 'block',
                width: '100%',
                padding: '12px 24px',
                backgroundColor: '#FF4081',
                color: 'white',
                textAlign: 'center',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#E91E63';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 64, 129, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#FF4081';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Padlet 열기 →
            </a>
            <a 
              href="https://ta.padlet.com/" 
              target="_blank" 
              rel="noopener"
              style={{
                display: 'block',
                width: '100%',
                padding: '10px 24px',
                backgroundColor: '#FFF',
                color: '#FF4081',
                textAlign: 'center',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: '500',
                fontSize: '0.875rem',
                border: '2px solid #FF4081',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#FFF0F5';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 64, 129, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#FFF';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Padlet 교육자료 보기 📚
            </a>
          </div>
        </div>

        {/* Gemini 카드 */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <h3 style={{ 
            fontSize: '1.25rem', 
            fontWeight: '600', 
            margin: 0,
            color: '#4285F4'
          }}>
            ✨ Gemini
          </h3>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            fontWeight: '500'
          }}>
            Google의 멀티모달 AI
          </p>
          <ul style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            paddingLeft: '20px',
            lineHeight: '1.6'
          }}>
            <li>이미지, 비디오 분석을 통한 수업 자료 개발</li>
            <li>Google Workspace와 연동한 협업 도구</li>
            <li>다양한 형식의 콘텐츠 생성</li>
          </ul>
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '8px',
            marginTop: 'auto'
          }}>
            <a 
              href="https://gemini.google.com" 
              target="_blank" 
              rel="noopener"
              style={{
                display: 'block',
                width: '100%',
                padding: '12px 24px',
                backgroundColor: '#4285F4',
                color: 'white',
                textAlign: 'center',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1976d2';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(66, 133, 244, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#4285F4';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Gemini 열기 →
            </a>
            <a 
              href="https://aistudio.google.com/" 
              target="_blank" 
              rel="noopener"
              style={{
                display: 'block',
                width: '100%',
                padding: '10px 24px',
                backgroundColor: '#FFF',
                color: '#4285F4',
                textAlign: 'center',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: '500',
                fontSize: '0.875rem',
                border: '2px solid #4285F4',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#E8F0FE';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(66, 133, 244, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#FFF';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              AI Studio 열기 🔬
            </a>
          </div>
        </div>

        {/* NotebookLM 카드 */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <h3 style={{ 
            fontSize: '1.25rem', 
            fontWeight: '600', 
            margin: 0,
            color: '#34A853'
          }}>
            📔 NotebookLM
          </h3>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            fontWeight: '500'
          }}>
            Google의 AI 기반 노트 작성 도구
          </p>
          <ul style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            paddingLeft: '20px',
            lineHeight: '1.6'
          }}>
            <li>문서, PDF, 웹사이트 업로드하여 AI와 대화</li>
            <li>학습 자료 요약 및 핵심 내용 추출</li>
            <li>출처 기반 답변 생성</li>
          </ul>
          <a 
            href="https://notebooklm.google.com" 
            target="_blank" 
            rel="noopener"
            style={{
              display: 'block',
              width: '100%',
              padding: '12px 24px',
              backgroundColor: '#34A853',
              color: 'white',
              textAlign: 'center',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              marginTop: 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2E7D32';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(52, 168, 83, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#34A853';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            NotebookLM 열기 →
          </a>
        </div>

        {/* Canva AI 카드 */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <h3 style={{ 
            fontSize: '1.25rem', 
            fontWeight: '600', 
            margin: 0,
            color: '#00C4CC'
          }}>
            🎨 Canva AI
          </h3>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            fontWeight: '500'
          }}>
            AI 기반 디자인 도구
          </p>
          <ul style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            paddingLeft: '20px',
            lineHeight: '1.6'
          }}>
            <li>AI를 활용한 수업 자료, 발표 자료 디자인</li>
            <li>인포그래픽, 포스터 자동 생성</li>
            <li>Magic Design, Magic Write 기능</li>
          </ul>
          <a 
            href="https://www.canva.com" 
            target="_blank" 
            rel="noopener"
            style={{
              display: 'block',
              width: '100%',
              padding: '12px 24px',
              backgroundColor: '#00C4CC',
              color: 'white',
              textAlign: 'center',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              marginTop: 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#00A0B0';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 196, 204, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#00C4CC';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Canva 열기 →
          </a>
        </div>
      </div>

      {/* 공유하기 섹션 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.5rem' }} id="공유하기">
        💬 참여자 공유 게시판
      </h2>
      <p style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.6' }}>
        연수 참여자분들이 공유한 아이디어와 자료입니다. Padlet에서 직접 여러분의 의견도 공유해보세요!
      </p>

      {/* Padlet 보드로 이동 버튼 */}
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <a 
          href="https://padlet.com/sunrin/ai-gemini-canva-ix9zuu4aehfg98pa" 
          target="_blank" 
          rel="noopener"
          style={{
            display: 'inline-block',
            padding: '14px 32px',
            backgroundColor: '#FF4081',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '1.125rem',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(255, 64, 129, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#E91E63';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(255, 64, 129, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#FF4081';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 64, 129, 0.3)';
          }}
        >
          📝 Padlet 보드에서 공유하기 →
        </a>
      </div>

      {/* Padlet 임베드 */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '24px',
        marginBottom: '32px'
      }}>
        <h3 style={{ 
          fontSize: '1.125rem', 
          fontWeight: '600', 
          marginBottom: '20px',
          color: '#333'
        }}>
          📝 실시간 공유 게시판
        </h3>
        
        <div style={{
          width: '100%',
          height: '600px',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          overflow: 'hidden'
        }}>
          <iframe 
            src="https://padlet.com/embed/ix9zuu4aehfg98pa"
            frameBorder="0"
            allow="camera;microphone;geolocation"
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            title="연수 참여자 공유 게시판"
          />
        </div>
        
        <p style={{
          marginTop: '12px',
          fontSize: '0.875rem',
          color: '#666',
          textAlign: 'center'
        }}>
          💡 위의 버튼을 클릭하여 게시판을 열어 공유해주세요!
        </p>
      </div>

      {/* 수업 적용 사례 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="수업-적용-사례">
        수업 적용 사례
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        AI 에듀테크를 활용한 실제 수업 사례를 소개합니다.<br/>
        <ul>
          <li>
            <b>사례 1: AI를 활용한 맞춤형 문제 제작</b>
            <ul>
              <li>학생 수준별로 난이도가 다른 문제 자동 생성</li>
              <li>즉각적인 피드백 제공으로 학습 효과 향상</li>
            </ul>
          </li>
          <li>
            <b>사례 2: AI 기반 수업 자료 제작</b>
            <ul>
              <li>교과서 내용을 AI로 요약 및 재구성</li>
              <li>시각 자료 자동 생성으로 수업 준비 시간 단축</li>
            </ul>
          </li>
          <li>
            <b>사례 3: 학생 글쓰기 지도</b>
            <ul>
              <li>AI를 활용한 초안 작성 및 퇴고 과정 지도</li>
              <li>문법, 표현, 구조에 대한 즉각적인 피드백</li>
            </ul>
          </li>
        </ul>
      </p>
      {/* 실습 과제 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="실습-과제">
        실습 과제
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        연수 중 진행할 실습 과제입니다.<br/>
        <ul>
          <li>
            <b>과제 1: Gemini로 수업 자료 제작하기</b>
            <ul>
              <li>Gemini를 활용하여 자신의 교과 수업 자료 제작</li>
              <li>이미지, 텍스트를 결합한 멀티모달 자료 생성</li>
            </ul>
          </li>
          <li>
            <b>과제 2: NotebookLM으로 학습 자료 요약하기</b>
            <ul>
              <li>교과서 또는 참고 자료를 NotebookLM에 업로드</li>
              <li>핵심 내용 추출 및 학생용 요약본 제작</li>
            </ul>
          </li>
          <li>
            <b>과제 3: Padlet으로 협업 수업 설계하기</b>
            <ul>
              <li>Padlet을 활용한 학생 협업 활동 기획</li>
              <li>실시간 피드백 및 공유 방법 구상</li>
            </ul>
          </li>
          <li>
            <b>과제 4: Canva AI로 수업 자료 디자인하기</b>
            <ul>
              <li>Magic Design을 활용한 시각 자료 제작</li>
              <li>학생 발표용 템플릿 및 인포그래픽 제작</li>
            </ul>
          </li>
        </ul>
      </p>
      {/* 참고 자료 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="참고-자료">
        참고 자료
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        AI 에듀테크 활용에 도움이 되는 참고 자료입니다.<br/>
        <ul>
          <li>
            <b>공식 문서 및 가이드</b>
            <ul>
              <li><a href="https://gemini.google.com" target="_blank" rel="noopener">Gemini 공식 사이트</a></li>
              <li><a href="https://notebooklm.google.com" target="_blank" rel="noopener">NotebookLM 공식 사이트</a></li>
              <li><a href="https://padlet.com/resources" target="_blank" rel="noopener">Padlet 활용 가이드</a></li>
              <li><a href="https://www.canva.com/designschool/" target="_blank" rel="noopener">Canva Design School</a></li>
            </ul>
          </li>
          <li>
            <b>교육용 AI 활용 커뮤니티</b>
            <ul>
              <li><a href="https://www.aiforeducation.io/" target="_blank" rel="noopener">AI for Education</a></li>
              <li>교육부 AI 디지털교과서 플랫폼</li>
              <li>Google for Education 커뮤니티</li>
            </ul>
          </li>
          <li>
            <b>추천 튜토리얼 및 자료</b>
            <ul>
              <li>Gemini를 활용한 교육 자료 제작 사례</li>
              <li>NotebookLM 활용 교육 사례</li>
              <li>Padlet 기반 협업 수업 디자인</li>
            </ul>
          </li>
        </ul>
      </p>
      <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.5rem' }} id="만족도-조사">
        연수 만족도 조사
      </h2>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '32px',
        marginBottom: '32px',
        textAlign: 'center'
      }}>
        <p style={{ 
          color: '#666', 
          marginBottom: '24px', 
          fontSize: '1.125rem', 
          lineHeight: '1.6',
          fontWeight: '500'
        }}>
          금일 연수 이수하시느라 고생 많으셨습니다. 🙏<br/>
          마지막으로 연수 만족도 조사를 부탁드립니다.
        </p>
        <a 
          href="https://docs.google.com/forms/d/e/1FAIpQLSfk3HKVW_-6N301IwlhU8-3hVsEm0FGA0iSSZBNv6FmAsDcBg/viewform" 
          target="_blank" 
          rel="noopener"
          style={{
            display: 'inline-block',
            padding: '16px 48px',
            backgroundColor: '#667eea',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '1.125rem',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#5a6fd8';
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(102, 126, 234, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#667eea';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
          }}
        >
          📝 만족도 조사 참여하기 →
        </a>
      </div>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        <b>연수 문의</b><br/>
        추가 문의사항이나 도움이 필요하신 경우 연수 담당자에게 연락해주세요.<br/>
        이메일: jihotech16@outlook.kr
      </p>
    </div>
  );
};

export default DeaGwamgAIEdutechTraining;